import React, { useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { useStoreValue, storeSet } from '../../../../store';

// components
import FormField from '../../../../components/FormField';
import ButtonFlat from '../../../../components/ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../../../../components/ButtonWrapper/components/ButtonFormSubmit';

const ProfileNotifications = () => {
    const userData = useStoreValue('userData');
    const notificationPreferences = userData?.notificationPreferences;

    const { control, handleSubmit, reset } = useForm({
        mode: 'onChange',
        defaultValues: {
            emailNotifications:    true,
            projectUpdates:        false,
            collaborationRequests: false,
            messages:              true,
            emailMarketing:        false,
        },
    });

    useEffect(() => {
        if (!notificationPreferences) return;
        reset({
            emailNotifications:    notificationPreferences.emailNotifications    ?? true,
            projectUpdates:        notificationPreferences.projectUpdates        ?? false,
            collaborationRequests: notificationPreferences.collaborationRequests ?? false,
            messages:              notificationPreferences.messages              ?? true,
            emailMarketing:        notificationPreferences.emailMarketing        ?? false,
        });
    }, [notificationPreferences]);

    const onSubmit = async (data) => {
        try {
            await storeSet('updateUserPreferences', data);
        } catch {
            // error already shown by action
        }
    };

    const handleCancel = () => {
        reset();
    };

    return (
        <div className="workbenchProfile workbenchProfile--notifications">
            <h3 className="workbenchProfile__sectionTitle">
                {__('Preferenze Notifiche', 'soundbetween')}
            </h3>

            <div className="workbenchProfile__notificationsSubsection">
                <h4>
                    {__('Impostazioni Notifiche', 'soundbetween')}
                </h4>
                <form
                    className="appForm profileNotificationsForm"
                    onSubmit={handleSubmit(onSubmit)}
                    noValidate
                >
                    <fieldset className="profileNotificationsForm__fields">
                        <FormField
                            type="switch"
                            name="emailNotifications"
                            label={__('Notifiche Email', 'soundbetween')}
                            description={__('Ricevi aggiornamenti via email', 'soundbetween')}
                            control={control}
                        />
                        <FormField
                            type="switch"
                            name="projectUpdates"
                            label={__('Aggiornamenti Progetti', 'soundbetween')}
                            description={__('Notifiche sui progetti a cui stai lavorando', 'soundbetween')}
                            control={control}
                        />
                        <FormField
                            type="switch"
                            name="collaborationRequests"
                            label={__('Richieste di Collaborazione', 'soundbetween')}
                            description={__('Quando qualcuno ti invita a un progetto', 'soundbetween')}
                            control={control}
                        />
                        <FormField
                            type="switch"
                            name="messages"
                            label={__('Messaggi', 'soundbetween')}
                            description={__('Notifiche per nuovi messaggi diretti', 'soundbetween')}
                            control={control}
                        />
                        <FormField
                            type="switch"
                            name="emailMarketing"
                            label={__('Email Marketing', 'soundbetween')}
                            description={__('Novità, suggerimenti e offerte speciali', 'soundbetween')}
                            control={control}
                        />
                    </fieldset>

                    <div className="appFormActions profileForm__actions">
                        <ButtonFlat size="md" type="button" onClick={handleCancel}>
                            {__('Annulla', 'soundbetween')}
                        </ButtonFlat>
                        <ButtonFormSubmit size="md">{__('Salva Preferenze', 'soundbetween')}</ButtonFormSubmit>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProfileNotifications;
